<template>
  <div class="module-rich-text">
    <div class="title font-semibold">
      {{ title }}
    </div>
    <div class="content quote typo" v-html="content" />
  </div>
</template>

<script>
/**
 * 图文（二）web组件
 */
import mixin from './mixin'

export default {
  name: 'ModuleRichText',
  mixins: [mixin],
}
</script>

<style lang="scss">
@import "assets/css/typo.scss";
</style>

<style lang="scss" scoped>
.module-rich-text {
  width: 1240px;
  margin: 0 auto;

  .title {
    position: relative;
    margin-bottom: 30px;
    font-size: 40px;
    font-family: Roboto-Flex, sans-serif;
    font-weight: 600;
    color: var(--txt-color-lv4);
    padding-left: 20px;

    &::before {
      display: block;
      position: absolute;
      left: 0;
      top: 12px;
      content: " ";
      width: 4px;
      height: 22px;
      background: url('./assets/title-line.png') no-repeat;
      background-size: 4px 22px;
    }
  }

  .content {
    padding: 50px 40px 40px;
    font-size: 20px;
    color: var(--txt-color-lv3);
    line-height: 34px;
    background-color: #fff;
    border-radius: 12px;
    border: 1px solid #f1f1f1;

    &.quote {
      background: url('./assets/quote-left-top.png') no-repeat 30px 19px, url('./assets/quote-right-bottom.png') no-repeat calc(100% - 30px) calc(100% - 19px);
      background-size: 45px 26px, 45px 26px;
      background-color: #fff;
    }
  }
}
</style>
